import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import { Router } from 'vue-router';
import { hidePageLoading } from '@src/core';

export default function initRouterGuard(router: Router) {
	NProgress.configure({ showSpinner: false });
	// 全局前置守卫
	router.beforeEach(async (to, from, next) => {
		console.log('beforeEach >', to, from);
		NProgress.start();
		return next();
	});

	// 全局后置钩子
	router.afterEach(() => {
		NProgress.done();
		hidePageLoading();
	});
}
